import React from 'react';
import '../css/Global.css';
import GlobalService from './GlobalService';

function Global() {
    return (
        <>
            <div className="global  p-5" >
                <h3 className=" text-center">Global consultancy</h3>
                <h5 className="white-3 text-center ">Lorem ipsum dolor sit, amet consectetur adipisicing.</h5>
                <div className=" d-flex flex-column justify-content-center ">

                    <div className="row justify-content-center">
                        <GlobalService content="Lorem ipsum " />
                        <GlobalService content="dolor sit" />
                        <GlobalService content="sit amet" />
                    </div>
                    <div className="row justify-content-center">
                        <GlobalService content="tur adipisicing" />
                        <GlobalService content="at vero sa" />
                        <GlobalService content="consectetur" />
                    </div>


                </div>
            </div>
        </>
    )
}

export default Global;
